<app-dialog-header [title]="'general.api_transaction_refund_modal_title' | translate"></app-dialog-header>
<mat-dialog-content> <h4>{{ 'general.api_transaction_refund_additional_actions' | translate }}</h4>
  <div class="flex flex-column-mobile flex-column-desktop">
    <div>
      <mat-form-field appearance="outline" class="no-hint">
        <mat-label>{{ 'general.api_transactions_payment_method' | translate }}</mat-label>
        <mat-select [(ngModel)]="paymentMethod" [ngModelOptions]="{standalone: true}" required>
          <mat-option *ngFor="let value of PaymentMethodValues" [value]="value">
            {{ ('general.api_transactions_payment_method_' + value.toLowerCase()) | translate }}
          </mat-option>
          <mat-option *ngIf="canDoPaymentReversal" [value]=" PaymentMethodEnum.EveryPay">
            {{ ('general.api_transactions_payment_method_' + PaymentMethodEnum.EveryPay.toLowerCase()) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <br>
  <app-totals-table [tableData]="tableData"></app-totals-table>
</mat-dialog-content>
<app-dialog-footer [dialogActions]="buttons"></app-dialog-footer>
<ng-template #buttons>
  <div class="flex flex-end max-width flex-mobile">
    <div class="flex-mobile">
      <button mat-button mat-dialog-close>
        {{'general.api_general_cancel' | translate}}
      </button>
      <button mat-flat-button color="primary" (click)="close(true)" [disabled]="!paymentMethod">
        {{'general.api_transaction_refund_modal_button_ok' | translate}}
      </button>
    </div>
  </div>
</ng-template>
